import NavBar from "../components/NavBar"
import AccountSection from "../components/AccountSection"
import SignOutButton from "../components/SignOutButton"
import { useAuth } from "../contexts/AuthContext"
export default function AccountPage() {
 const { currentUser } = useAuth()
 return <div className="min-h-screen bg-gray-50"><NavBar /><main className="max-w-2xl mx-auto p-4 space-y-6"><h1 className="text-2xl font-semibold">Your account</h1><section className="bg-white rounded-xl p-4 space-y-3"><p>{currentUser?.name}</p><p>{currentUser?.email}</p><SignOutButton /></section><AccountSection /></main></div>
}
